import React from 'react';
import { ClinicInfoPanel } from '../info/clinicInfoParts';
import ClinicSettingsListSkeleton from '../subparts/ClinicSettingsListSkeleton';

function RecallSkeleton() {
    return (
        <div className="clinic-settings-stack">
            <ClinicInfoPanel title="Recall Hours" icon="bi-clock-history">
                <ClinicSettingsListSkeleton rows={7} />
            </ClinicInfoPanel>
            <ClinicInfoPanel title="Daily Recall Limits" icon="bi-bell">
                <ClinicSettingsListSkeleton rows={3} />
            </ClinicInfoPanel>
            <ClinicInfoPanel title="Recall Sequence" icon="bi-diagram-3">
                <ClinicSettingsListSkeleton rows={3} />
            </ClinicInfoPanel>
        </div>
    );
}

export default RecallSkeleton;
